//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const pulldownDefaultConfig = {
  content: '下拉刷新',
  height: 40,
  autoRefresh: false,
  downContent: '下拉刷新',
  upContent: '释放后刷新',
  loadingContent: '正在刷新...',
  clsPrefix: 'xs-plugin-pulldown-',
}
const pullupDefaultConfig = {
  content: '上拉加载更多',
  pullUpHeight: 60,
  height: 40,
  autoRefresh: false,
  downContent: '释放后加载',
  upContent: '上拉加载更多',
  loadingContent: '加载中...',
  clsPrefix: 'xs-plugin-pullup-',
}
import * as apiConst from '../service/api/api-const'
export default {
  name: 'check_room_service',
  data() {
    return {
      get_host: host.host,
      tab_index: 0,
      babySelectShow: false, //宝宝筛选显示
      showFormList: true, //显示表单列表
      personalMemberInfo: [],
      form_list: [],
      data_list: [], //表单数组
      start_date: '', //开始日期
      end_date: '', //结束日期
      shift_value: '', //班次值
      shift_arr: [], //班次选项
      min_date: '', //最小日期限制
      memberInfo: {
        room_name: '',
        name: '',
        phone: '',
        package: '',
        liveDate: '',
        childBirth: '',
        birthType: '',
        babyType: [
          {
            label: '顺产',
            value: '1',
          },
          {
            label: '剖宫产',
            value: '2',
          },
          {
            label: '小产',
            value: '3',
          },
          {
            label: '不知道',
            value: '0',
          },
        ],
      },
      form_id: '',
      from_title: '',
      page: '1',
      host: apiConst.host,
      pullupDefaultConfig: pullupDefaultConfig,
      pulldownDefaultConfig: pulldownDefaultConfig,
      newForm: [
        {
          id: 1001,
          name: '婴儿护理操作记录表',
          style: true,
        },
        {
          id: 1002,
          name: '婴儿护理记录单(1)',
          style: true,
        },
        {
          id: 1003,
          name: '婴儿护理记录单(2)',
          style: true,
        },
        {
          id: 1004,
          name: '婴儿喂养记录单',
          style: true,
        },
        {
          id: 1005,
          name: '产妇每日生理护理记录表',
          style: true,
        },
        {
          id: 1006,
          name: '产妇膳食记录表',
          style: true,
        },
        {
          id: 1007,
          name: '产妇康复护理评估记录单',
          style: true,
        },
        {
          id: 1008,
          name: '产妇健康咨询记录表',
          style: true,
        },
        {
          id: 1009,
          name: '新生儿健康咨询记录表',
          style: true,
        },
        {
          id: 1010,
          name: '产妇特殊护理记录表',
          style: true,
        },
        {
          id: 1011,
          name: '婴儿特殊护理记录表',
          style: true,
        },
        {
          id: 1012,
          name: '喂药委托书(新)',
          style: true,
        },
        {
          id: 1013,
          name: '月子基本护理常识(新)',
          style: true,
        },
        {
          id: 1014,
          name: '查房记录(新)',
          style: true,
        },
      ],
      formListDetailList: [],
      formListDetailListPage: 1,
      nurser_name: [], //查房人列表
      baby_list: [], //宝宝列表
      get_baby_id: '',
      cfrText: '',
    }
  },
  methods: {
    //清除表单
    clearFrom() {
      console.info('清除表单')
      this.forFormIDUseMethod('tab')
    },
    //添加记录
    addRecord() {
      let formId = parseInt(this.form_id)
      console.info(formId)
      let query = {
        id: this.$route.query.id,
        form_id: formId,
        tabVal: this.$route.query.tabVal,
      }
      switch (formId) {
        case 1001:
          this.$router.push({
            path: '/bb_form_f',
            query: query,
          })
          break
        case 1002:
          this.$router.push({
            path: '/bb_form_b',
            query: query,
          })
          break
        case 1003:
          this.$router.push({
            path: '/bb_form_c',
            query: query,
          })
          break
        case 1004:
          this.$router.push({
            path: '/bb_form_a',
            query: query,
          })
          break
        case 1005:
          this.$router.push({
            path: '/maternal_form_d',
            query: query,
          })
          break
        case 1006:
          this.$router.push({
            path: '/maternal_form_b',
            query: query,
          })
          break
        case 1007:
          this.$router.push({
            path: '/maternal_form_c',
            query: query,
          })
          break
        case 1008:
          this.$router.push({
            path: '/christmas_form_one',
            query: query,
          })
          break
        case 1009:
          this.$router.push({
            path: '/christmas_form_two',
            query: query,
          })
          break
        case 1010:
          this.$router.push({
            path: '/christmas_form_three',
            query: query,
          })
          break
        case 1011:
          this.$router.push({
            path: '/christmas_form_four',
            query: query,
          })
          break
        case 1012:
          this.$router.push({
            path: '/medicine_commissioned',
            query: query,
          })
          break
        case 1013:
          this.$router.push({
            path: '/basic_nursing',
            query: query,
          })
          break
        case 1014:
          this.$router.push({
            path: '/new_check_room_record',
            query: query,
          })
          break
        default:
          this.$router.push({
            path: '/add_from_record',
            query: query,
          })
      }
    },
    //时间戳转日期格式
    formatDateTime(inputTime) {
      var date = new Date(parseInt(inputTime) * 1000)
      var y = date.getFullYear()
      var m = date.getMonth() + 1
      m = m < 10 ? '0' + m : m
      var d = date.getDate()
      d = d < 10 ? '0' + d : d
      var h = date.getHours()
      h = h < 10 ? '0' + h : h
      var minute = date.getMinutes()
      var second = date.getSeconds()
      minute = minute < 10 ? '0' + minute : minute
      second = second < 10 ? '0' + second : second
      return y + '-' + m + '-' + d
    },
    //点击查房表
    tabItem(index) {
      this.form_id = this.form_list[index].id
      this.from_title = this.form_list[index].name
      if (this.form_list[index].id == '999') {
        this.$router.push({
          path: '/check_room_record',
          query: {
            id: this.$route.query.id,
            tabVal: this.$route.query.tabVal,
          },
        })
        return
      }
      this.forFormIDUseMethod('tab')
    },
    //选择开始日期
    start_date_congirm(value) {
      this.formListDetailListPage = 1
      this.formListDetailList = []
      this.min_date = value
      this.start_date = value
      console.info('选择开始日期')
      this.forFormIDUseMethod()
    },
    //选择结束日期
    end_date_congirm(value) {
      this.formListDetailListPage = 1
      this.formListDetailList = []
      this.end_date = value
      console.info('选择结束日期')
      this.forFormIDUseMethod()
    },
    //选择班次
    plantPickerChange(value) {
      this.formListDetailListPage = 1
      this.formListDetailList = []
      console.info('选择班次')
      this.forFormIDUseMethod()
    },
    //选择宝宝
    babyPickerChange(value) {
      this.formListDetailListPage = 1
      this.formListDetailList = []
      for (let item of this.baby_list) {
        if (value == item.name) {
          if (item.live_time == '0') {
            this.$vux.toast.show({
              type: 'cancel',
              text: item.name + '暂未入住',
            })
            return
          }
        }
      }
      this.forFormIDUseMethod()
    },
    //获取表单查房列表
    apiFormList() {
      let that = this
      let params = {
        token: this.$cookie.get('token'),
      }
      Api.checkRoomApi.roundFormList(params).then((res) => {
        console.info(res)
        if (res.errcode == 1) {
          this.form_list = res.data
          // this.form_list.push({
          //     id: '999',
          //     name: '查房记录'
          // })
          let arr = [...this.newForm, ...this.form_list]
          this.form_list = arr
          let id_arr = []
          for (let item of this.form_list) {
            id_arr.push(parseInt(item.id))
          }
          if (this.$route.query.form_id) {
            //查看详情赋值查房单ID
            this.form_id = this.$route.query.form_id
            let get_form_index = id_arr.indexOf(
              parseInt(this.$route.query.form_id)
            )
            this.tab_index = get_form_index
            this.from_title = this.form_list[get_form_index].name
          } else {
            //初始化赋值表查房单ID
            this.form_id = this.newForm[0].id
            this.from_title = this.newForm[0].name
          }
          this.forFormIDUseMethod('login')
        } else {
          this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo,
          })
        }
      })
    },
    //请求用户基本信息
    apiMemberInfo() {
      let params = {
        token: this.$cookie.get('token'),
        maternal_info_id: this.$route.query.id,
      }
      Api.checkRoomApi.memberInfo(params).then((res) => {
        console.info('请求用户基本信息', res)
        if (res.errcode == 1) {
          this.memberInfo.room_name = res.data.room_name
          this.memberInfo.name = res.data.name
          this.memberInfo.phone = res.data.phone
          this.memberInfo.package = res.data.package_name
          this.memberInfo.liveDate = this.formatDateTime(res.data.live_time)
          this.memberInfo.childBirth = this.formatDateTime(res.data.child_birth)
          let birthType = ''
          for (let item of this.memberInfo.babyType) {
            if (res.data.birth_type == item.value) {
              birthType = item.label
            }
          }
          this.memberInfo.birthType = birthType
        } else {
          this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo,
          })
        }
      })
    },
    dateFormat(_date) {
      let date = new Date(_date)
      let time = Date.parse(date) / 1000
      return time
    },
    //获取自定义表单列表
    apiGroupList(str) {
      this.$vux.loading.show({
        text: '正在加载',
      })
      let params = {
        token: this.$cookie.get('token'),
        maternal_info_id: this.$route.query.id,
        form_id: this.form_id,
        stime:
          this.start_date == ''
            ? ''
            : this.dateFormat(this.start_date + ' 00:00:00:000'),
        etime:
          this.end_date == ''
            ? ''
            : this.dateFormat(this.end_date + ' 23:59:59:999'),
        plans: this.shift_value,
        page: this.page,
        isWap: '1',
      }
      let that = this
      console.info(params)
      Api.checkRoomApi.getGroupList(params).then((res) => {
        console.info('自定义表单', res)
        if (res.errcode == 1) {
          that.page++
          if (res.data.list.length) {
            for (let item of res.data.list) {
              that.data_list.push(item)
            }
            for (let item of that.data_list) {
              for (let item0 of item.form_data) {
                for (let item1 of item0.row_list) {
                  for (let item2 of item1.content) {
                    for (let val of that.personalMemberInfo) {
                      if (item2.column_name == val.name) {
                        item2.my_answer[0] = val.value
                      }
                    }
                  }
                }
              }
            }
            // this.personalMemberInfo
            that.shift_arr = res.data.plans_list
            if (str == 'refresh') {
              that.$refs.scrollerBottom.enablePullup() //启用上拉加载插件
              that.$refs.scrollerBottom.donePulldown() //设置下拉刷新操作完成，在数据加载后执行
            }
            if (res.data.page.page == res.data.page.page_count) {
              that.$refs.scrollerBottom.disablePullup() // 禁用上拉加载，在没有更多数据时执行
            } else {
              that.$refs.scrollerBottom.donePullup() //设置上拉加载操作完成，在数据加载后执行
            }
          } else {
            that.$vux.toast.show({
              type: 'cancel',
              text: '暂无更多数据',
            })
          }
          that.$vux.loading.hide()
        } else {
          that.$vux.loading.hide()
          that.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo,
          })
        }
      })
    },
    //编辑记录表
    editForm(answer_id) {
      this.$router.push({
        path: './add_from_record',
        query: {
          id: this.$route.query.id,
          form_id: this.form_id,
          answer_id: answer_id,
          tabVal: this.$route.query.tabVal,
        },
      })
    },
    goBack() {
      this.$router.push({
        path: './maternal_service',
        query: {
          tabVal: this.$route.query.tabVal,
          id: this.$route.query.id,
        },
      })
    },
    //自定义表单下拉刷新
    refresh() {
      this.data_list = []
      this.page = '1'
      this.apiGroupList('refresh')
    },
    //自定义表单上拉加载
    loadMore() {
      this.apiGroupList()
    },
    //固定表单下拉刷新
    refresh2() {
      this.formListDetailList = []
      this.formListDetailListPage = 1
      console.info('固定表单下拉刷新')
      this.forFormIDUseMethod()
    },
    //固定表单上拉加载
    loadMore2() {
      console.info('固定表单上拉加载')
      this.forFormIDUseMethod()
    },
    //请求答案列表
    getAnswerList() {
      let params = {
        token: this.$cookie.get('token'),
        maternal_info_id: this.$route.query.id,
      }
      Api.checkRoomApi.getColumnList(params).then((res) => {
        console.log('请求答案列表', res)
        if (res.errcode == 1) {
          this.personalMemberInfo = res.data
        } else {
          this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo,
          })
        }
      })
    },
    //请求婴儿护理操作记录表所有列表
    apiBabyCare(str, handle) {
      let params = {
        token: this.$cookie.get('token'),
        page: this.formListDetailListPage,
        maternal_info_id: this.$route.query.id,
        shifts:
          this.shift_value == undefined ? '' : this.shift_value.substring(0, 2),
        baby_id: this.get_baby_id,
        stime: this.start_date,
        etime: this.end_date,
      }
      this.$vux.loading.show({
        text: '正在加载',
      })
      console.info(params)
      Api.bbFormApi.getBabyCareOperalist(params).then((res) => {
        console.info('请求婴儿护理操作记录表', res)
        if (res.data) {
          let shift_value = this.$route.query.shifts_value
          this.shift_arr = []
          if (res.data.shifts_count_list) {
            for (let item of res.data.shifts_count_list) {
              this.shift_arr.push(item.shifts + '(' + item.count + ')')
              if (shift_value && handle == 'login') {
                if (item.shifts == shift_value) {
                  this.shift_value = item.shifts + '(' + item.count + ')'
                }
              }
            }
          }
        }
        if (res.errcode == 200) {
          console.info('页数：' + this.formListDetailListPage)
          this.formListDetailListPage++
          if (res.data.list.length) {
            for (let item of res.data.list) {
              this.formListDetailList.push(item)
            }
          }
          if (str == 'refresh') {
            this.$refs.scrollerBottom2.enablePullup() //启用上拉加载插件
            this.$refs.scrollerBottom2.donePulldown() //设置下拉刷新操作完成，在数据加载后执行
          }

          if (res.data.page.page == res.data.page.page_count) {
            this.$refs.scrollerBottom2.disablePullup() // 禁用上拉加载，在没有更多数据时执行
          } else {
            this.$refs.scrollerBottom2.donePullup() //设置上拉加载操作完成，在数据加载后执行
          }
          this.$vux.loading.hide()
          return
        } else if (res.errcode == 400) {
          this.$vux.loading.hide()
          this.$vux.toast.show({
            type: 'cancel',
            text: '暂无数据',
          })
        } else {
          this.$vux.loading.hide()
          this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo,
          })
        }
      })
    },
    //请求婴儿护理记录单（1）所有列表
    apiBabyRecord(str, handle) {
      let params = {
        token: this.$cookie.get('token'),
        page: this.formListDetailListPage,
        maternal_info_id: this.$route.query.id,
        shifts:
          this.shift_value == undefined ? '' : this.shift_value.substring(0, 2),
        baby_id: this.get_baby_id,
        stime: this.start_date,
        etime: this.end_date,
      }
      this.$vux.loading.show({
        text: '正在加载',
      })
      console.info(params)
      Api.bbFormApi.getBabyNursOneDataList(params).then((res) => {
        console.info('请求婴儿护理记录单（1）', res)
        if (res.data) {
          let shift_value = this.$route.query.shifts_value
          this.shift_arr = []
          if (res.data.shifts_count_list) {
            for (let item of res.data.shifts_count_list) {
              this.shift_arr.push(item.shifts + '(' + item.count + ')')
              if (shift_value && handle == 'login') {
                if (item.shifts == shift_value) {
                  this.shift_value = item.shifts + '(' + item.count + ')'
                }
              }
            }
          }
        }
        if (res.errcode == 200) {
          console.info('页数：' + this.formListDetailListPage)
          this.formListDetailListPage++
          if (res.data.list.length) {
            for (let item of res.data.list) {
              let cfrText = ''
              if (this.nurser_name.length) {
                for (let val of this.nurser_name) {
                  if (item.check_id == val.id) {
                    cfrText = val.user_name
                  }
                }
              }
              item.cfrText = cfrText
            
              if (item.front_case == 1) {
                item.front_case = '平坦'
              } else if (item.front_case == 2) {
                item.front_case = '肿胀'
              } else if (item.front_case == 3) {
                item.front_case = '凹陷'
              } else {
                item.front_case = ''
              }
              if (item.skin_colour == '1') {
                item.skin_colour = '红润'
              } else if (item.skin_colour == '2') {
                item.skin_colour = '黄染'
              }
              if (item.front_fontanelle == '1') {
                item.front_fontanelle = '平坦'
              } else if (item.front_fontanelle == '2') {
                item.front_fontanelle = '肿胀'
              } else if (item.front_fontanelle == '3') {
                item.front_fontanelle = '凹陷'
              }
              this.formListDetailList.push(item)
            }
          }
          if (str == 'refresh') {
            this.$refs.scrollerBottom2.enablePullup() //启用上拉加载插件
            this.$refs.scrollerBottom2.donePulldown() //设置下拉刷新操作完成，在数据加载后执行
          }
          if (res.data.page.page == res.data.page.page_count) {
            this.$refs.scrollerBottom2.disablePullup() // 禁用上拉加载，在没有更多数据时执行
          } else {
            this.$refs.scrollerBottom2.donePullup() //设置上拉加载操作完成，在数据加载后执行
          }
          this.$vux.loading.hide()
        } else if (res.errcode == 400) {
          this.$vux.loading.hide()
          this.$vux.toast.show({
            type: 'cancel',
            text: '暂无数据',
          })
        } else {
          this.$vux.loading.hide()
          this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo,
          })
        }
      })
    },
    //请求婴儿护理记录单（2）所有列表
    apiBabyRecordTwo(str, handle) {
      let params = {
        token: this.$cookie.get('token'),
        page: this.formListDetailListPage,
        maternal_info_id: this.$route.query.id,
        shifts:
          this.shift_value == undefined ? '' : this.shift_value.substring(0, 2),
        baby_id: this.get_baby_id,
        stime: this.start_date,
        etime: this.end_date,
      }
      this.$vux.loading.show({
        text: '正在加载',
      })
      console.info(params)
      Api.bbFormApi.getBabyNursTwoDataList(params).then((res) => {
        console.info('请求婴儿护理记录单（2）', res)
        if (res.data) {
          let shift_value = this.$route.query.shifts_value
          this.shift_arr = []
          if (res.data.shifts_count_list) {
            for (let item of res.data.shifts_count_list) {
              this.shift_arr.push(item.shifts + '(' + item.count + ')')
              if (shift_value && handle == 'login') {
                if (item.shifts == shift_value) {
                  this.shift_value = item.shifts + '(' + item.count + ')'
                }
              }
            }
          }
        }
        if (res.errcode == 200) {
          console.info('页数：' + this.formListDetailListPage)
          this.formListDetailListPage++
          if (res.data.list.length) {
            for (let val of res.data.list) {
              let cfrText = ''
              if (this.nurser_name.length) {
                for (let item of this.nurser_name) {
                  if (val.check_id == item.id) {
                    cfrText = item.user_name
                  }
                }
              }
              val.cfrText = cfrText
              let skinArr = []
              if (val.skin.length) {
                for (let item of val.skin) {
                  if (item == '1') {
                    skinArr.push('正常')
                  } else if (item == '2') {
                    skinArr.push('黄疸')
                  } else if (item == '3') {
                    skinArr.push('糜烂')
                  } else if (item == '4') {
                    skinArr.push('脓疱疹')
                  } else if (item == '5') {
                    skinArr.push('湿疹')
                  } else if (item == '6') {
                    skinArr.push('尿布疹')
                  }
                }
                val.skin = skinArr.join(',')
              }
              if (val.eye == '1') {
                val.eye = '正常'
              } else if (val.eye == '2') {
                val.eye = '分泌物'
              }

              if (val.oral == '1') {
                val.oral = '光滑'
              } else if (val.oral == '2') {
                val.oral = '破溃'
              } else if (val.oral == '3') {
                val.oral = '鹅口疮'
              }

              if (val.umbilical == '1') {
                val.umbilical = '干燥'
              } else if (val.umbilical == '2') {
                val.umbilical = '出血'
              } else if (val.umbilical == '3') {
                val.umbilical = '脱落'
              } else if (val.umbilical == '4') {
                val.umbilical = '分泌物'
              }

              if (val.tension_of_limbs == '1') {
                val.tension_of_limbs = '良好'
              } else if (val.tension_of_limbs == '2') {
                val.tension_of_limbs = '受限'
              }

              if (val.nerve_reflex == '1') {
                val.nerve_reflex = '正常'
              } else if (val.nerve_reflex == '2') {
                val.nerve_reflex = '迟钝'
              }
              this.formListDetailList.push(val)
            }
          }
          if (str == 'refresh') {
            this.$refs.scrollerBottom2.enablePullup() //启用上拉加载插件
            this.$refs.scrollerBottom2.donePulldown() //设置下拉刷新操作完成，在数据加载后执行
          }
          if (res.data.page.page == res.data.page.page_count) {
            this.$refs.scrollerBottom2.disablePullup() // 禁用上拉加载，在没有更多数据时执行
          } else {
            this.$refs.scrollerBottom2.donePullup() //设置上拉加载操作完成，在数据加载后执行
          }
          this.$vux.loading.hide()
        } else if (res.errcode == 400) {
          this.$vux.loading.hide()
          this.$vux.toast.show({
            type: 'cancel',
            text: '暂无数据',
          })
        } else {
          this.$vux.loading.hide()
          this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo,
          })
        }
      })
    },
    //请求婴儿喂养记录单所有列表
    apiGetBabyFeedingRecordList(str, handle) {
      let params = {
        token: this.$cookie.get('token'),
        page: this.formListDetailListPage,
        maternal_info_id: this.$route.query.id,
        shifts:
          this.shift_value == undefined ? '' : this.shift_value.substring(0, 2),
        baby_id: this.get_baby_id,
        stime: this.start_date,
        etime: this.end_date,
      }
      this.$vux.loading.show({
        text: '正在加载',
      })
      console.info(params)
      Api.bbFormApi.getBabyFeedingRecordList(params).then((res) => {
        console.info('请求婴儿喂养记录单', res)
        if (res.data) {
          let shift_value = this.$route.query.shifts_value
          this.shift_arr = []
          if (res.data.shifts_count_list) {
            for (let item of res.data.shifts_count_list) {
              this.shift_arr.push(item.shifts + '(' + item.count + ')')
              if (shift_value && handle == 'login') {
                if (item.shifts == shift_value) {
                  this.shift_value = item.shifts + '(' + item.count + ')'
                }
              }
            }
          }
        }
        if (res.errcode == 200) {
          console.info('页数：' + this.formListDetailListPage)
          this.formListDetailListPage++
          if (res.data.list.length) {
            for (let item of res.data.list) {
              this.formListDetailList.push(item)
            }
          }
          if (str == 'refresh') {
            this.$refs.scrollerBottom2.enablePullup() //启用上拉加载插件
            this.$refs.scrollerBottom2.donePulldown() //设置下拉刷新操作完成，在数据加载后执行
          }
          if (res.data.page.page == res.data.page.page_count) {
            this.$refs.scrollerBottom2.disablePullup() // 禁用上拉加载，在没有更多数据时执行
          } else {
            this.$refs.scrollerBottom2.donePullup() //设置上拉加载操作完成，在数据加载后执行
          }
          this.$vux.loading.hide()
        } else if (res.errcode == 400) {
          this.$vux.loading.hide()
          this.$vux.toast.show({
            type: 'cancel',
            text: '暂无数据',
          })
        } else {
          this.$vux.loading.hide()
          this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo,
          })
        }
      })
    },
    //请求产妇膳食记录表所有列表
    apiGetMaternalMealRecordsList(str, handle) {
      let params = {
        token: this.$cookie.get('token'),
        page: this.formListDetailListPage,
        maternal_info_id: this.$route.query.id,
        shifts:
          this.shift_value == undefined ? '' : this.shift_value.substring(0, 2),
        stime: this.start_date,
        etime: this.end_date,
      }
      this.$vux.loading.show({
        text: '正在加载',
      })
      console.info(params)
      Api.bbFormApi.getMaternalMealRecordsList(params).then((res) => {
        console.info(res)
        if (res.data) {
          let shift_value = this.$route.query.shifts_value
          this.shift_arr = []
          if (res.data.shifts_count_list) {
            for (let item of res.data.shifts_count_list) {
              this.shift_arr.push(item.shifts + '(' + item.count + ')')
              if (shift_value && handle == 'login') {
                if (item.shifts == shift_value) {
                  this.shift_value = item.shifts + '(' + item.count + ')'
                }
              }
            }
          }
        }
        if (res.errcode == 200) {
          console.info('页数：' + this.formListDetailListPage)
          this.formListDetailListPage++
          if (res.data.list.length) {
            for (let item of res.data.list) {
              this.formListDetailList.push(item)
            }
          }
          if (str == 'refresh') {
            this.$refs.scrollerBottom2.enablePullup() //启用上拉加载插件
            this.$refs.scrollerBottom2.donePulldown() //设置下拉刷新操作完成，在数据加载后执行
          }
          if (res.data.page.page == res.data.page.page_count) {
            this.$refs.scrollerBottom2.disablePullup() // 禁用上拉加载，在没有更多数据时执行
          } else {
            this.$refs.scrollerBottom2.donePullup() //设置上拉加载操作完成，在数据加载后执行
          }
          this.$vux.loading.hide()
        } else if (res.errcode == 400) {
          this.$vux.loading.hide()
          this.$vux.toast.show({
            type: 'cancel',
            text: '暂无数据',
          })
        } else {
          this.$vux.loading.hide()
          this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo,
          })
        }
      })
    },
    //请求产妇康复护理评估记录表所有列表
    apiGetMaterRehNursEvalList(str, handle) {
      let params = {
        token: this.$cookie.get('token'),
        page: this.formListDetailListPage,
        maternal_info_id: this.$route.query.id,
        shifts:
          this.shift_value == undefined ? '' : this.shift_value.substring(0, 2),
        stime: this.start_date,
        etime: this.end_date,
      }
      this.$vux.loading.show({
        text: '正在加载',
      })
      console.info(params)
      Api.bbFormApi.getMaterRehNursEvalList(params).then((res) => {
        console.info('请求产妇康复护理评估记录表', res)
        if (res.data) {
          let shift_value = this.$route.query.shifts_value
          this.shift_arr = []
          if (res.data.shifts_count_list) {
            for (let item of res.data.shifts_count_list) {
              this.shift_arr.push(item.shifts + '(' + item.count + ')')
              if (shift_value && handle == 'login') {
                if (item.shifts == shift_value) {
                  this.shift_value = item.shifts + '(' + item.count + ')'
                }
              }
            }
          }
        }
        if (res.errcode == 200) {
          console.info('页数：' + this.formListDetailListPage)
          this.formListDetailListPage++
          if (res.data.list.length) {
            for (let val of res.data.list) {
              let cfrText = ''
              if (this.nurser_name.length) {
                for (let item of this.nurser_name) {
                  if (val.check_id == item.id) {
                    cfrText = item.user_name
                  }
                }
              }
              val.cfrText = cfrText
              this.formListDetailList.push(val)
            }
          }

          if (str == 'refresh') {
            this.$refs.scrollerBottom2.enablePullup() //启用上拉加载插件
            this.$refs.scrollerBottom2.donePulldown() //设置下拉刷新操作完成，在数据加载后执行
          }
          if (res.data.page.page == res.data.page.page_count) {
            this.$refs.scrollerBottom2.disablePullup() // 禁用上拉加载，在没有更多数据时执行
          } else {
            this.$refs.scrollerBottom2.donePullup() //设置上拉加载操作完成，在数据加载后执行
          }
          this.$vux.loading.hide()
        } else if (res.errcode == 400) {
          this.$vux.loading.hide()
          this.$vux.toast.show({
            type: 'cancel',
            text: '暂无数据',
          })
        } else {
          this.$vux.loading.hide()
          this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo,
          })
        }
      })
    },
    //请求产妇每日生理护理记录所有列表
    apiGetMaternalEverydayPhysiologyList(str, handle) {
      let params = {
        token: this.$cookie.get('token'),
        page: this.formListDetailListPage,
        maternal_info_id: this.$route.query.id,
        shifts:
          this.shift_value == undefined ? '' : this.shift_value.substring(0, 2),
        stime: this.start_date,
        etime: this.end_date,
      }
      this.$vux.loading.show({
        text: '正在加载',
      })
      console.info(params)
      Api.bbFormApi.getMaternalEverydayPhysiologyList(params).then((res) => {
        console.info('请求产妇每日生理护理记录', res)
        if (res.data) {
          let shift_value = this.$route.query.shifts_value
          this.shift_arr = []
          if (res.data.shifts_count_list) {
            for (let item of res.data.shifts_count_list) {
              this.shift_arr.push(item.shifts + '(' + item.count + ')')
              if (shift_value && handle == 'login') {
                if (item.shifts == shift_value) {
                  this.shift_value = item.shifts + '(' + item.count + ')'
                }
              }
            }
          }
        }
        if (res.errcode == 200) {
          console.info('页数：' + this.formListDetailListPage)
          this.formListDetailListPage++
          if (res.data.list.length) {
            for (let item of res.data.list) {
              if (item.diet == '1') {
                item.diet = '普通'
              } else if (item.diet == '2') {
                item.diet = '特殊'
              }
              if (item.sport == '1') {
                item.sport = '舒适'
              } else if (item.sport == '2') {
                item.sport = '较累'
              }
              if (item.sport_text == '') {
                item.sport = item.sport
              } else {
                item.sport = item.sport + '：' + item.sport_text
              }
              item.sport = item.sport + item.sport_text
              this.formListDetailList.push(item)
            }
          }
          if (str == 'refresh') {
            this.$refs.scrollerBottom2.enablePullup() //启用上拉加载插件
            this.$refs.scrollerBottom2.donePulldown() //设置下拉刷新操作完成，在数据加载后执行
          }
          if (res.data.page.page == res.data.page.page_count) {
            this.$refs.scrollerBottom2.disablePullup() // 禁用上拉加载，在没有更多数据时执行
          } else {
            this.$refs.scrollerBottom2.donePullup() //设置上拉加载操作完成，在数据加载后执行
          }
          this.$vux.loading.hide()
        } else if (res.errcode == 400) {
          this.$vux.loading.hide()
          this.$vux.toast.show({
            type: 'cancel',
            text: '暂无数据',
          })
        } else {
          this.$vux.loading.hide()
          this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo,
          })
        }
      })
    },
    //请求产妇健康咨询记录表
    apiGetMatarnalHeathRecordList(str, handle) {
      let params = {
        token: this.$cookie.get('token'),
        page: this.formListDetailListPage,
        maternal_info_id: this.$route.query.id,
        shifts:
          this.shift_value.substring(0, 2) == '早班'
            ? '1'
            : this.shift_value.substring(0, 2) == '中班'
            ? '2'
            : this.shift_value.substring(0, 2) == '晚班'
            ? '3'
            : '',
        stime: this.start_date,
        etime: this.end_date,
      }
      this.$vux.loading.show({
        text: '正在加载',
      })
      console.info(params)
      Api.chritmasFormApi.matarnalHeathRecordList(params).then((res) => {
        console.info('请求产妇健康咨询记录表', res)
        if (res.data) {
          let shift_value = this.$route.query.shifts_value
          this.shift_arr = []
          if (res.data.shifts_count_list) {
            for (let item of res.data.shifts_count_list) {
              this.shift_arr.push(item.shifts + '(' + item.count + ')')
              if (shift_value && handle == 'login') {
                if (item.shifts == shift_value) {
                  this.shift_value = item.shifts + '(' + item.count + ')'
                }
              }
            }
          }
        }
        if (res.errcode == 200) {
          console.info('页数：' + this.formListDetailListPage)
          this.formListDetailListPage++
          if (res.data.list.length) {
            for (let item of res.data.list) {
              let cfrText = ''
              for (let val of this.nurser_name) {
                if (val.id == item.agent_id) {
                  cfrText = val.user_name
                }
              }
              let obj = {
                delivery_type: item.delivery_type,
                advisory_date:
                  item.advisory_date == '0000-00-00' ? '' : item.advisory_date,
                agent_id: cfrText,
                agent_sign: item.agent_sign,
                breast:
                  item.breast == '1'
                    ? '左硬结'
                    : item.breast == '2'
                    ? '右硬结'
                    : item.breast == '3'
                    ? '无异常'
                    : item.breast == '4'
                    ? '正常'
                    : item.breast == '5'
                    ? '双侧硬结'
                    : '',
                chapped_nipple:
                  item.chapped_nipple == '1'
                    ? '有'
                    : item.chapped_nipple == '2'
                    ? '无'
                    : '',
                healing:
                  item.healing == '1'
                    ? '良好'
                    : item.healing == '2'
                    ? '不良'
                    : '',
                id: item.id,
                lochia_amount: item.lochia_amount,
                lochia_color:
                  item.lochia_color == '1'
                    ? '暗红'
                    : item.lochia_color == '2'
                    ? '鲜红'
                    : item.lochia_color == '3'
                    ? '白色'
                    : item.lochia_color == '4'
                    ? '正常'
                    : '',
                lochia_taste:
                  item.lochia_taste == '1'
                    ? '有'
                    : item.lochia_taste == '2'
                    ? '无'
                    : '',
                milk_amount:
                  item.milk_amount == '1'
                    ? '多'
                    : item.milk_amount == '2'
                    ? '中'
                    : item.milk_amount == '3'
                    ? '少'
                    : '回奶',
                pee: item.pee == '1' ? '有' : item.pee == '2' ? '无' : '',
                postpartum_days:
                  item.postpartum_days == '0' ? '' : item.postpartum_days,
                shifts:
                  item.shifts == '1'
                    ? '早班'
                    : item.shifts == '2'
                    ? '中班'
                    : item.shifts == '3'
                    ? '晚班'
                    : '',
                special_case: item.special_case,
                stool:
                  item.stool == '1' ? '正常' : item.stool == '2' ? '异常' : '',
                //    uterus_place:item.uterus_place == "1" ? "脐上指" : item.uterus_place == "2" ? "脐下指" : item.uterus_place == "3" ? "完全入盘" : item.uterus_place == "4" ? "完全入盘" : '',
                uterus_place: item.uterus_place,
              }
              this.formListDetailList.push(obj)
            }
          }
          if (str == 'refresh') {
            this.$refs.scrollerBottom2.enablePullup() //启用上拉加载插件
            this.$refs.scrollerBottom2.donePulldown() //设置下拉刷新操作完成，在数据加载后执行
          }
          if (res.data.page.page == res.data.page.page_count) {
            this.$refs.scrollerBottom2.disablePullup() // 禁用上拉加载，在没有更多数据时执行
          } else {
            this.$refs.scrollerBottom2.donePullup() //设置上拉加载操作完成，在数据加载后执行
          }
          this.$vux.loading.hide()
        } else if (res.errcode == 400) {
          this.$vux.loading.hide()
          this.$vux.toast.show({
            type: 'cancel',
            text: '暂无数据',
          })
        } else {
          this.$vux.loading.hide()
          this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo,
          })
        }
      })
    },
    //请求(新生儿)健康咨询记录表列表
    apiGetBabyHeathRecordList(str, handle) {
      let params = {
        token: this.$cookie.get('token'),
        page: this.formListDetailListPage,
        maternal_info_id: this.$route.query.id,
        baby_id: this.get_baby_id,
        shifts:
          this.shift_value.substring(0, 2) == '早班'
            ? '1'
            : this.shift_value.substring(0, 2) == '中班'
            ? '2'
            : this.shift_value.substring(0, 2) == '晚班'
            ? '3'
            : '',
        stime: this.start_date,
        etime: this.end_date,
      }
      this.$vux.loading.show({
        text: '正在加载',
      })
      console.info(params)
      Api.chritmasFormApi.BabyHeathRecord(params).then((res) => {
        console.info('请求(新生儿)健康咨询记录表列表', res)
        if (res.data) {
          let shift_value = this.$route.query.shifts_value
          this.shift_arr = []
          if (res.data.shifts_count_list) {
            for (let item of res.data.shifts_count_list) {
              this.shift_arr.push(item.shifts + '(' + item.count + ')')
              if (shift_value && handle == 'login') {
                if (item.shifts == shift_value) {
                  this.shift_value = item.shifts + '(' + item.count + ')'
                }
              }
            }
          }
        }
        if (res.errcode == 200) {
          console.info('页数：' + this.formListDetailListPage)
          this.formListDetailListPage++
          if (res.data.list.length) {
            for (let item of res.data.list) {
              for (let val of this.nurser_name) {
                if (val.id == item.agent_id) {
                  item.agent_id = val.user_name
                }
              }
              if (item.shifts == '1') {
                item.shifts = '早班'
              } else if (item.shifts == '2') {
                item.shifts = '中班'
              } else if (item.shifts == '3') {
                item.shifts = '晚班'
              }
              for (let child of this.baby_list) {
                if (item.baby_id == child.id) {
                  item.liveData = this.formatDateTime(child.live_time)
                  item.baby_name = child.name
                }
              }
              if (item.advisory_date == '0000-00-00') {
                item.advisory_date = ''
              }
              if (item.birth_day == '0') {
                item.birth_day = ''
              }
              if (item.jaundice == '0') {
                item.jaundice = ''
              }
              if (item.shifts == '0') {
                item.shifts = ''
              }
              // if(item.deal == '1'){
              //     item.deal = '加强脐带部护理'
              // }else if(item.deal == '2'){
              //     item.deal = '加强母乳喂养'
              // }
              this.formListDetailList.push(item)
            }
          }
          if (str == 'refresh') {
            this.$refs.scrollerBottom2.enablePullup() //启用上拉加载插件
            this.$refs.scrollerBottom2.donePulldown() //设置下拉刷新操作完成，在数据加载后执行
          }
          if (res.data.page.page == res.data.page.page_count) {
            this.$refs.scrollerBottom2.disablePullup() // 禁用上拉加载，在没有更多数据时执行
          } else {
            this.$refs.scrollerBottom2.donePullup() //设置上拉加载操作完成，在数据加载后执行
          }
          this.$vux.loading.hide()
        } else if (res.errcode == 400) {
          this.$vux.loading.hide()
          this.$vux.toast.show({
            type: 'cancel',
            text: '暂无数据',
          })
        } else {
          this.$vux.loading.hide()
          this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo,
          })
        }
      })
    },
    //请求产妇特殊护理记录表
    apiGetMatarnalSpecialNursingRecordList(str, handle) {
      let params = {
        token: this.$cookie.get('token'),
        page: this.formListDetailListPage,
        maternal_info_id: this.$route.query.id,
        shifts:
          this.shift_value.substring(0, 2) == '早班'
            ? '1'
            : this.shift_value.substring(0, 2) == '中班'
            ? '2'
            : this.shift_value.substring(0, 2) == '晚班'
            ? '3'
            : '',
        stime: this.start_date,
        etime: this.end_date,
      }
      this.$vux.loading.show({
        text: '正在加载',
      })
      console.info(params)
      Api.chritmasFormApi.MatarnalSpecialNursingRecord(params).then((res) => {
        console.info('请求产妇特殊护理记录表', res)
        if (res.data) {
          let shift_value = this.$route.query.shifts_value
          this.shift_arr = []
          if (res.data.shifts_count_list) {
            for (let item of res.data.shifts_count_list) {
              this.shift_arr.push(item.shifts + '(' + item.count + ')')
              if (shift_value && handle == 'login') {
                if (item.shifts == shift_value) {
                  this.shift_value = item.shifts + '(' + item.count + ')'
                }
              }
            }
          }
        }
        if (res.errcode == 200) {
          console.info('页数：' + this.formListDetailListPage)
          this.formListDetailListPage++
          if (res.data.list.length) {
            for (let item of res.data.list) {
              for (let val of this.nurser_name) {
                if (val.id == item.agent_id) {
                  item.agent_id = val.user_name
                }
              }
              if (item.shifts == '1') {
                item.shifts = '早班'
              } else if (item.shifts == '2') {
                item.shifts = '中班'
              } else if (item.shifts == '3') {
                item.shifts = '晚班'
              }
              if (item.record_date == '0000-00-00') {
                item.record_date = ''
              }
              if (item.shifts == '0') {
                item.shifts = ''
              }
              this.formListDetailList.push(item)
            }
          }
          if (str == 'refresh') {
            this.$refs.scrollerBottom2.enablePullup() //启用上拉加载插件
            this.$refs.scrollerBottom2.donePulldown() //设置下拉刷新操作完成，在数据加载后执行
          }
          if (res.data.page.page == res.data.page.page_count) {
            this.$refs.scrollerBottom2.disablePullup() // 禁用上拉加载，在没有更多数据时执行
          } else {
            this.$refs.scrollerBottom2.donePullup() //设置上拉加载操作完成，在数据加载后执行
          }
          this.$vux.loading.hide()
        } else if (res.errcode == 400) {
          this.$vux.loading.hide()
          this.$vux.toast.show({
            type: 'cancel',
            text: '暂无数据',
          })
        } else {
          this.$vux.loading.hide()
          this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo,
          })
        }
      })
    },
    //请求婴儿特殊护理记录表
    apiGetbabySpecialNursingRecordList(str, handle) {
      let params = {
        token: this.$cookie.get('token'),
        page: this.formListDetailListPage,
        maternal_info_id: this.$route.query.id,
        baby_id: this.get_baby_id,
        shifts:
          this.shift_value.substring(0, 2) == '早班'
            ? '1'
            : this.shift_value.substring(0, 2) == '中班'
            ? '2'
            : this.shift_value.substring(0, 2) == '晚班'
            ? '3'
            : '',
        stime: this.start_date,
        etime: this.end_date,
      }
      this.$vux.loading.show({
        text: '正在加载',
      })
      console.info(params)
      Api.chritmasFormApi.babySpecialNursingRecord(params).then((res) => {
        console.info('请求婴儿特殊护理记录表', res)
        if (res.data) {
          let shift_value = this.$route.query.shifts_value
          this.shift_arr = []
          if (res.data.shifts_count_list) {
            for (let item of res.data.shifts_count_list) {
              this.shift_arr.push(item.shifts + '(' + item.count + ')')
              if (shift_value && handle == 'login') {
                if (item.shifts == shift_value) {
                  this.shift_value = item.shifts + '(' + item.count + ')'
                }
              }
            }
          }
        }
        if (res.errcode == 200) {
          console.info('页数：' + this.formListDetailListPage)
          this.formListDetailListPage++
          if (res.data.list.length) {
            for (let item of res.data.list) {
              for (let val of this.nurser_name) {
                if (val.id == item.agent_id) {
                  item.agent_id = val.user_name
                }
              }
              if (item.shifts == '1') {
                item.shifts = '早班'
              } else if (item.shifts == '2') {
                item.shifts = '中班'
              } else if (item.shifts == '3') {
                item.shifts = '晚班'
              }
              for (let child of this.baby_list) {
                if (item.baby_id == child.id) {
                  item.sex = child.sex == '1' ? '男' : '女'
                  item.baby_name = child.name
                }
              }
              if (item.record_date == '0000-00-00') {
                item.record_date = ''
              }
              if (item.postpartum_days == '0') {
                item.postpartum_days = ''
              }
              if (item.breast == '0') {
                item.breast = ''
              }
              if (item.shifts == '0') {
                item.shifts = ''
              }
              this.formListDetailList.push(item)
            }
          }
          if (str == 'refresh') {
            console.info('启用上拉加载插件')
            this.$refs.scrollerBottom2.enablePullup() //启用上拉加载插件
            this.$refs.scrollerBottom2.donePulldown() //设置下拉刷新操作完成，在数据加载后执行
          }
          if (res.data.page.page == res.data.page.page_count) {
            this.$refs.scrollerBottom2.disablePullup() // 禁用上拉加载，在没有更多数据时执行
          } else {
            this.$refs.scrollerBottom2.donePullup() //设置上拉加载操作完成，在数据加载后执行
          }
          this.$vux.loading.hide()
        } else if (res.errcode == 400) {
          this.$vux.loading.hide()
          this.$vux.toast.show({
            type: 'cancel',
            text: '暂无数据',
          })
        } else {
          this.$vux.loading.hide()
          this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo,
          })
        }
      })
    },
    //请求喂药委托书
    apiGetFeedDrugEntrustUrlListList(str, handle) {
      let params = {
        token: this.$cookie.get('token'),
        page: this.formListDetailListPage,
        maternal_info_id: this.$route.query.id,
      }
      this.$vux.loading.show({
        text: '正在加载',
      })
      console.info(params)
      Api.checkRoomApi.getFeedDrugEntrustUrlList(params).then((res) => {
        console.info('请求喂药委托书', res)
        if (res.data) {
          let shift_value = this.$route.query.shifts_value
          this.shift_arr = []
          if (res.data.shifts_count_list) {
            for (let item of res.data.shifts_count_list) {
              this.shift_arr.push(item.shifts + '(' + item.count + ')')
              if (shift_value && handle == 'login') {
                if (item.shifts == shift_value) {
                  this.shift_value = item.shifts + '(' + item.count + ')'
                }
              }
            }
          }
        }
        if (res.errcode == 200) {
          console.info('页数：' + this.formListDetailListPage)
          this.formListDetailListPage++
          if (res.data.list.length) {
            for (let item of res.data.list) {
              this.formListDetailList.push(item)
            }
          }
          if (str == 'refresh') {
            console.info('启用上拉加载插件')
            this.$refs.scrollerBottom2.enablePullup() //启用上拉加载插件
            this.$refs.scrollerBottom2.donePulldown() //设置下拉刷新操作完成，在数据加载后执行
          }
          if (res.data.page.page == res.data.page.page_count) {
            this.$refs.scrollerBottom2.disablePullup() // 禁用上拉加载，在没有更多数据时执行
          } else {
            this.$refs.scrollerBottom2.donePullup() //设置上拉加载操作完成，在数据加载后执行
          }
          this.$vux.loading.hide()
        } else if (res.errcode == 400) {
          this.$vux.loading.hide()
          this.$vux.toast.show({
            type: 'cancel',
            text: '暂无数据',
          })
        } else {
          this.$vux.loading.hide()
          this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo,
          })
        }
      })
    },
    //请求月子基本护理常识
    apiGetConfinementSenseListUrlList(str, handle) {
      let params = {
        token: this.$cookie.get('token'),
        page: this.formListDetailListPage,
        maternal_info_id: this.$route.query.id,
      }
      this.$vux.loading.show({
        text: '正在加载',
      })
      console.info(params)
      Api.checkRoomApi.getConfinementSenseListUrlList(params).then((res) => {
        console.info('请求月子基本护理常识', res)
        if (res.data) {
          let shift_value = this.$route.query.shifts_value
          this.shift_arr = []
          if (res.data.shifts_count_list) {
            for (let item of res.data.shifts_count_list) {
              this.shift_arr.push(item.shifts + '(' + item.count + ')')
              if (shift_value && handle == 'login') {
                if (item.shifts == shift_value) {
                  this.shift_value = item.shifts + '(' + item.count + ')'
                }
              }
            }
          }
        }
        if (res.errcode == 200) {
          console.info('页数：' + this.formListDetailListPage)
          this.formListDetailListPage++
          if (res.data.list.length) {
            for (let item of res.data.list) {
              this.formListDetailList.push(item)
            }
          }
          if (str == 'refresh') {
            console.info('启用上拉加载插件')
            this.$refs.scrollerBottom2.enablePullup() //启用上拉加载插件
            this.$refs.scrollerBottom2.donePulldown() //设置下拉刷新操作完成，在数据加载后执行
          }
          if (res.data.page.page == res.data.page.page_count) {
            this.$refs.scrollerBottom2.disablePullup() // 禁用上拉加载，在没有更多数据时执行
          } else {
            this.$refs.scrollerBottom2.donePullup() //设置上拉加载操作完成，在数据加载后执行
          }
          this.$vux.loading.hide()
        } else if (res.errcode == 400) {
          this.$vux.loading.hide()
          this.$vux.toast.show({
            type: 'cancel',
            text: '暂无数据',
          })
        } else {
          this.$vux.loading.hide()
          this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo,
          })
        }
      })
    },
    //新增表单点击详情进入详情页
    editFormDetailList(id) {
      let form_id = parseInt(this.form_id)
      let query = {
        id: this.$route.query.id,
        form_id: this.form_id,
        list_id: id,
        tabVal: this.$route.query.tabVal,
      }
      switch (form_id) {
        case 1001:
          this.$router.push({
            path: './bb_form_f',
            query: query,
          })
          break
        case 1002:
          this.$router.push({
            path: './bb_form_b',
            query: query,
          })
          break
        case 1003:
          this.$router.push({
            path: './bb_form_c',
            query: query,
          })
          break
        case 1004:
          this.$router.push({
            path: './bb_form_a',
            query: query,
          })
          break
        case 1005:
          this.$router.push({
            path: './maternal_form_d',
            query: query,
          })
          break
        case 1006:
          this.$router.push({
            path: './maternal_form_b',
            query: query,
          })
          break
        case 1007:
          this.$router.push({
            path: './maternal_form_c',
            query: query,
          })
          break
        case 1008:
          this.$router.push({
            path: './christmas_form_one',
            query: query,
          })
          break
        case 1009:
          this.$router.push({
            path: './christmas_form_two',
            query: query,
          })
          break
        case 1010:
          this.$router.push({
            path: './christmas_form_three',
            query: query,
          })
          break
        case 1011:
          this.$router.push({
            path: './christmas_form_four',
            query: query,
          })
          break
        case 1012:
          this.$router.push({
            path: './medicine_commissioned',
            query: query,
          })
          break
        case 1013:
          this.$router.push({
            path: './basic_nursing',
            query: query,
          })
          break
      }
    },
    //根据表单ID执行不同方法
    forFormIDUseMethod(handle) {
      console.info('根据表单ID执行不同方法')
      let form_id = parseInt(this.form_id)
      if (
        form_id === 1001 ||
        form_id === 1002 ||
        form_id === 1003 ||
        form_id === 1004 ||
        form_id === 1009 ||
        form_id === 1011
      ) {
        this.babySelectShow = true
      }
      if (handle == 'tab') {
        console.log('如果是点击tab')
        // 如果是点击tab
        this.formListDetailList = []
        this.formListDetailListPage = 1
        this.start_date = ''
        this.end_date = ''
        this.shift_value = ''
        this.get_baby_id = ''
      }
      // let s_arr =  ['早班','中班','晚班']
      // this.shift_arr = s_arr
      switch (form_id) {
        case 1001:
          this.showFormList = false
          this.apiBabyCare('refresh', handle)
          break
        case 1002:
          this.showFormList = false
          this.apiBabyRecord('refresh', handle)

          break
        case 1003:
          this.showFormList = false
          this.apiBabyRecordTwo('refresh', handle)
          break
        case 1004:
          this.showFormList = false
          this.apiGetBabyFeedingRecordList('refresh', handle)
          break
        case 1005:
          this.showFormList = false
          this.apiGetMaternalEverydayPhysiologyList('refresh', handle)
          break
        case 1006:
          this.showFormList = false
          this.apiGetMaternalMealRecordsList('refresh', handle)
          break
        case 1007:
          this.showFormList = false
          this.apiGetMaterRehNursEvalList('refresh', handle)
          break
        case 1008:
          this.showFormList = false
          this.apiGetCfrList('christmas_form_one', handle)
          break
        case 1009:
          this.showFormList = false
          this.apiGetCfrList('christmas_form_two', handle)
          break
        case 1010:
          this.showFormList = false
          this.apiGetCfrList('christmas_form_three', handle)
          break
        case 1011:
          this.showFormList = false
          this.apiGetCfrList('christmas_form_four', handle)
          break
        case 1012:
          this.showFormList = false
          this.apiGetFeedDrugEntrustUrlListList('refresh', handle)
          break
        case 1013:
          this.showFormList = false
          this.apiGetConfinementSenseListUrlList('refresh', handle)
          break
        case 1014:
          this.$router.push({
            path: '/new_check_room_record',
            query: {
              id: this.$route.query.id,
              tabVal: this.$route.query.tabVal,
            },
          })
          break
        default:
          //自定义表单内容
          this.showFormList = true
          this.getAnswerList() //个人信息获取的答案
          this.refresh()
      }
    },
    //获取查房人列表
    apiGetCfrList(name) {
      let params = {
        token: this.$cookie.get('token'),
        store_id: this.$cookie.get('store_id'),
      }
      Api.checkRoomApi.getCheckInfo(params).then((res) => {
        console.info('获取查房人列表')
        console.info(res)
        if (res.errcode == 1) {
          this.nurser_name = res.data.nurser_name //过滤了离院，
          //
          if (name == 'christmas_form_one') {
            this.apiGetMatarnalHeathRecordList('refresh')
          } else if (name == 'christmas_form_two') {
            this.apiGetBabyHeathRecordList('refresh')
          } else if (name == 'christmas_form_three') {
            this.apiGetMatarnalSpecialNursingRecordList('refresh')
          } else if (name == 'christmas_form_four') {
            this.apiGetbabySpecialNursingRecordList('refresh')
          }
        } else {
          this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo,
          })
        }
      })
    },
    //获取宝宝数量
    get_baby_list() {
      this.$vux.loading.show({
        text: '正在加载',
      })
      let params = {
        token: this.$cookie.get('token'),
        maternal_info_id: this.$route.query.id,
      }
      Api.monthLiveApi.babyList(params).then((res) => {
        console.info('获取宝宝数量')
        console.info(res)
        if (res.errcode == 1) {
          this.baby_list = res.data
          this.$vux.loading.hide()
        } else {
          this.$vux.loading.hide()
          this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo,
          })
        }
      })
    },
  },
  created() {
    let start_date = this.$route.query.start_date
    console.log(start_date)
    if (start_date) {
      this.start_date = start_date
    }
    let end_date = this.$route.query.end_date
    if (end_date) {
      this.end_date = end_date
    }
    this.get_baby_list()
    this.apiGetCfrList() //获取查房人列表
    this.apiMemberInfo() //基础信息
    this.apiFormList() //表单列表
  },
}



// WEBPACK FOOTER //
// ./src/components/check_room_service.vue